export class Target {
    constructor(
      public hash?: string,
      public title?: string
    ) { }

    clone() {
      return new Target(
        this.hash,
        this.title
      );
    }
  }

